<template>
  <div>
    <router-link
      v-if="user.admin"
      :to="{ name: 'adminAssets' }"
      class="text-primary-1"
    >
      Admin
    </router-link>


    <div class="flex gap-4">
      <div class="flex items-center">
        <UserHelp />
        <a
          :href="authAction.href"
          class="text-primary-1 pl-1 text-sm lg:text-base"
          v-on:click="authAction.action"
        >
          {{ authAction.text }}
        </a>
      </div>
      <div class="hidden lg:flex">
        <HelpCircle />
        <a
          :href="authAction.href"
          class="text-primary-1 pl-1"
          v-on:click="authAction.action"
        >
          CONTACT US
        </a>
      </div>
    </div>
    <Button
      v-if="!authenticated"
      @click="authAction.action"
      tag="a"
      :href="authAction.href"
      target="_blank"
      variant="secondary"
      class="w-[100%] mt-4 absolute lg:relative left-0"
      :class="[authAction.href === '#' && 'hidden']"
    >
      Open an account
    </Button>
    <Button
      v-if="authenticated"
      tag="a"
      href="/account"
      variant="secondary"
      class="w-[100%] mt-4 absolute lg:relative left-0"
    >
      My Account
    </Button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "./Button.vue";
import UserHelp from "./icons/UserHelp.vue";
import HelpCircle from "./icons/HelpCircle.vue";

export default {
  name: "UserBar",
  methods: {
    ...mapActions(["logout"]),
    closeMenu() {
      this.$emit("close-menu");
    },
    navigateToHome() {
      this.$router.push('/');
    },
    handleLogout(event) {
      event.preventDefault();
      this.logout();
      this.text = "SIGN IN"
      this.navigateToHome();
    },
  },
  computed: {
    ...mapGetters(["authenticated", "user", "loginRedirect"]),

    authAction: function() {
      if (this.authenticated === true) {
        return {
          text: "Log Out",
          href: "/",
          action: this.handleLogout,
        };
      } else {
        return {
          text: "SIGN IN",
          href: this.loginRedirect,
          action: () => {
            /* nothing to do */
          },
        };
      }
    },
  },
  components: { Button, UserHelp, HelpCircle },
};
</script>
